import {
  supportTicketAddMessage,
  supportTicketCreate,
  supportTicketGet,
  supportTicketsList,
  supportUploadAttachments,
} from './supportApi';

const STATUS_LABELS = {
  open: 'Open',
  waiting: 'Waiting',
  resolved: 'Resolved',
};

const normalizeTicket = (ticket) => ({
  ...ticket,
  updatedAt: ticket.updatedAt || ticket.createdAt || null,
});

export const listUserTickets = (firebase, uid, onUpdate) => {
  if (!uid) return () => {};
  let active = true;
  let timerId;
  let backendUnavailable = false;

  const load = async () => {
    if (backendUnavailable) return;
    try {
      const data = await supportTicketsList(firebase);
      if (data?.unavailable) {
        backendUnavailable = true;
        if (active) onUpdate([]);
        return;
      }
      if (!active) return;
      const items = (data?.items || []).map((item) => normalizeTicket({
        id: item.id || item.projectId || item.key || item.ticketId,
        ...item,
      }));
      onUpdate(items);
    } catch (error) {
      console.error('Failed to load support tickets:', error);
    }
  };

  load();
  timerId = setInterval(load, 30000);

  return () => {
    active = false;
    if (timerId) clearInterval(timerId);
  };
};

export const fetchTicketMessages = async (firebase, ticketId, uid) => {
  if (!ticketId) return [];
  const ticket = await supportTicketGet(firebase, ticketId, uid ? { uid } : {});
  return ticket?.messages || [];
};

export const addTicketMessage = async (firebase, ticketId, message, uid) => {
  if (!ticketId) return;
  await supportTicketAddMessage(firebase, ticketId, {
    ...message,
    uid: message.uid || uid || firebase?.auth?.currentUser?.uid || '',
  }, uid ? { uid } : {});
};

export const uploadSupportAttachments = async (firebase, uid, ticketId, files = []) => {
  if (!uid || !ticketId || !files.length) return [];
  return supportUploadAttachments(firebase, ticketId, files);
};

export const createTicket = async (firebase, uid, ticketPayload, files = []) => {
  if (!uid) throw new Error('Missing user');
  const payload = {
    uid,
    name: ticketPayload.name || '',
    email: ticketPayload.email || '',
    phone: ticketPayload.phone || '',
    subject: ticketPayload.subject || 'Support request',
    type: ticketPayload.type || 'Technical issue',
    priority: ticketPayload.priority || 'normal',
    description: ticketPayload.description || '',
    diagnostics: ticketPayload.diagnostics || {},
    attachments: [],
  };
  const ticket = await supportTicketCreate(firebase, payload);

  if (files.length && ticket?.id) {
    const attachments = await uploadSupportAttachments(firebase, uid, ticket.id, files);
    if (attachments.length) {
      await addTicketMessage(
        firebase,
        ticket.id,
        {
          sender: 'user',
          text: 'Attachments added.',
          attachments,
        },
        uid,
      );
      ticket.attachments = attachments;
    }
  }

  return ticket;
};

export const getStatusLabel = (status) => STATUS_LABELS[status] || 'Open';
